module.exports = __webpack_public_path__ + "static/ey-f1974fc228781bd310f0e76b5613bc6c.png";